function round(value, digits) {
  if (!Number.isFinite(value)) {
    return null;
  }
  return Number(value.toFixed(digits));
}

function ratio(total, count, digits) {
  return count > 0 ? round(total / count, digits) : null;
}

export function toChartSeries(teamWeeks, oppWeeks) {
  const pairs = teamWeeks
    .map((team, index) => ({ team, opp: oppWeeks[index] }))
    .filter((pair) => Boolean(pair.team) && Boolean(pair.opp));

  const plays = [];
  const yardsPerPlay = [];
  const timeOfPossession = [];

  let teamPlayTotal = 0;
  let oppPlayTotal = 0;
  let teamYardTotal = 0;
  let oppYardTotal = 0;
  let teamTopTotal = 0;
  let oppTopTotal = 0;

  pairs.forEach(({ team, opp }) => {
    const week = team.week.week;

    const teamPlays = team.passAtt + team.rushAtt;
    const oppPlays = opp.passAtt + opp.rushAtt;
    const teamYards = team.passYds + team.rushYds;
    const oppYards = opp.passYds + opp.rushYds;
    const teamTop = team.timeOfPos / 60;
    const oppTop = opp.timeOfPos / 60;

    teamPlayTotal += teamPlays;
    oppPlayTotal += oppPlays;
    teamYardTotal += teamYards;
    oppYardTotal += oppYards;
    teamTopTotal += teamTop;
    oppTopTotal += oppTop;

    plays.push({ week, team: teamPlays, opp: oppPlays });
    yardsPerPlay.push({
      week,
      team: ratio(teamYards, teamPlays, 1),
      opp: ratio(oppYards, oppPlays, 1),
    });
    timeOfPossession.push({
      week,
      team: round(teamTop, 2),
      opp: round(oppTop, 2),
    });
  });

  const games = pairs.length;

  return {
    plays,
    yardsPerPlay,
    timeOfPossession,
    averages: {
      plays: {
        team: ratio(teamPlayTotal, games, 2),
        opp: ratio(oppPlayTotal, games, 2),
      },
      yardsPerPlay: {
        team: ratio(teamYardTotal, teamPlayTotal, 2),
        opp: ratio(oppYardTotal, oppPlayTotal, 2),
      },
      timeOfPossession: {
        team: ratio(teamTopTotal, games, 2),
        opp: ratio(oppTopTotal, games, 2),
      },
    },
  };
}

export function toLeagueRows(teamStats) {
  return teamStats.map((stats) => ({
    ...stats,
    teamId: stats.team.id,
    teamAbbr: stats.team.abbreviation,
  }));
}
